import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subject, Subscription, takeUntil } from 'rxjs';
import { DailyLogService } from './daily-log.service';
import { CommonService } from 'src/app/services/common.service';
import { MatTableDataSource } from '@angular/material/table';
import { PdfMakeService } from './pdf-make.service';
import { CommentDailyLogComponent } from './comment-daily-log/comment-daily-log.component';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog';
import { TabStateService } from '../services/tabs-state.service';

@Component({
  selector: 'app-daily-logs',
  templateUrl: './daily-logs.component.html',
  styleUrls: ['./daily-logs.component.scss']
})
export class DailyLogsComponent implements OnInit, OnDestroy {
  //lastWeekLogs = [];
  //thisWeekDailyLogs = [];
  contractor_account_id: string
  user_id: string
  allLogs = [];
  projectId: any;
  //yesterdaylogsData = [];
  bid_ext_id: any;
  projectDetail: any;
  userData: any;
  project_id: string;
  displayedColumns: string[] = ['created_name', 'type', 'actions'];
  isFranchisee: boolean = false;
  loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  selected: boolean[] = [];
  noneSelected: boolean = true;
  allSelected: boolean = false;
  business: string;
  logo: string;
  activeSubTab: 'current' | 'closed' | 'my schedule' = 'current';
  private destroy$ = new Subject<void>();
  constructor(private dlService: DailyLogService, private snackbarService: SnackbarService, public dialog: MatDialog, private route: ActivatedRoute, private router: Router, private commonService: CommonService, private pdfServ: PdfMakeService, private tabState: TabStateService) { }
  subTab: string;
  ngOnInit(): void {
    // this.projectId = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe((query: any) => {
      this.projectId = query?.id;
    })
    this.tabState.getSubtab()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sub => {
        this.activeSubTab = sub;
      });

    // this.bid_ext_id = this.route.snapshot.paramMap.get('id2');
    // console.log(this.bid_ext_id);
    // this.contractor_account_id=this.route.snapshot.paramMap.get('contractor_account_id');
    if (sessionStorage.getItem('project_detail')) this.projectDetail = JSON.parse(sessionStorage.getItem('project_detail'));
    this.userData = JSON.parse(sessionStorage.getItem('userdata'));
    this.project_id = this.projectDetail?.project_id
    this.isFranchisee = this.commonService?.isFranchisee;
    this.contractor_account_id = this.isFranchisee ? this.commonService.franchiseeContractor_id : this.userData?.subcontractor_id;
    this.user_id = this.isFranchisee ? this.commonService.franchiseeContractor_id : this.userData?.subcontractor_id;
    console.log(this.user_id)
    // this.cont
    console.log("projectID", this.projectId, "contractorId", this.contractor_account_id)
    this.getDailyLogs();
    this.business = sessionStorage.getItem('Business');
    if (this.business === 'REFRESH') {
      this.logo = '../../../assets/images/Refresh-logo-2.svg'
    }
    else if (this.business === 'ZONES') {
      this.logo = '../../../assets/images/zones.svg'
    }
  }

  getDailyLogs() {
    console.log("pro det", this.projectDetail)
    this.dlService.getDailyLogs(this.projectId, this.contractor_account_id).subscribe(data => {
      console.log(data);
      this.allLogs = data?.logs.sort((a, b) => {
        const dateA = new Date(a?.created_at ?? "").getTime();
        const dateB = new Date(b?.created_at ?? "").getTime();
        return dateB - dateA;
      });
      console.log("allLogs", this.allLogs)
      this.selected = this.allLogs.map(() => false);
    })
  }
  navigateToDailyLog() {
    this.router.navigate([`/dashboard/details/${this.projectId}/daily-logs/add`], {
      queryParams: {
        projectId: this.projectId,
        section: 'daily-logs'
      }
    })
  }
  back() {
    this.router.navigate([`/dashboard/details/${this.projectId}/daily-logs`])
  }
  async downloadSelected() {
    this.loadingSubject.next(true);
    const selectedIndexes = this.selected
      .map((isChecked, index) => isChecked ? index : -1)
      .filter(index => index !== -1);
    let arrayToBeSentForPdf = [];
    for (let selected of selectedIndexes) {
      arrayToBeSentForPdf?.push(this.allLogs[selected])
    }
    arrayToBeSentForPdf.sort((a, b) => {
      const dateA = new Date(a.customerDataForPdf?.created_at ?? "").getTime();
      const dateB = new Date(b.customerDataForPdf?.created_at ?? "").getTime();
      return dateB - dateA;
    });
    console.log(arrayToBeSentForPdf)

    await this.pdfServ.generatePdf(arrayToBeSentForPdf, this.logo

    )
    this.loadingSubject.next(false);

    console.log('Selected Indices:', selectedIndexes);
  }
  onSelectedLogChange(index: number, value: boolean) {
    console.log(this.selected)
    this.noneSelected = this.selected?.every(log => log === false) ? true : false;
    console.log(this.noneSelected)
    console.log(`Checkbox #${index + 1} changed to`, value);
    // You can perform any action you want here
  }
  selectAllLogs() {
    this.selected = this.selected?.map(log => log = true);
    this.allSelected = true;
    this.noneSelected = false;
  }
  deSelectAllLogs() {
    this.selected = this.selected?.map(log => log = false);
    this.noneSelected = true;
    this.allSelected = false;
  }

  getIconUrl(icon): string {
    return `http://openweathermap.org/img/wn/${icon}@2x.png`
  };

  async downloadSingleLog(index) {
    await this.pdfServ.generatePdf([this.allLogs[index]], this.logo)
  };

  downloadFile(file) {
    if (file?.file_path && file?.file_path !== '') {
      window.open(file?.file_path, '_blank');
    }
  }

  openDialog(log, type: string, event: Event): void {
    if (log?.created_by !== this.user_id && type == 'Attachment') {
      this.openSnackbar('You can only add attachments to the log created by you!');
      return;
    }
    event.stopPropagation();
    let data = {
      daily_log_id: log?.daily_log_id,
      project_id: this.projectId,
      user_id: this.user_id,
      type: type
    }
    const dialogRef = this.dialog.open(CommentDailyLogComponent, {
      data: data,
      width: '480px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dialog closed with result:', result);
        console.log(true); // or handle specific logic here
        this.getDailyLogs();
      } else {
        console.log('Dialog closed without result.');
        console.log(false); // or handle logic for cancel
        // this.getDailyLogsOnID();
      }
    });
  }

  openSnackbar(message: string) {
    this.snackbarService.open(message);
  }

  deleteAttachment(file: any, type: string) {
    if (this.loadingSubject.value) {
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
        modalTitle: 'Confirm Deletion',
        message: `Are you sure you want to delete this ${type}?`,
        buttonText: {
          ok: 'Delete',
          cancel: 'Cancel'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.loadingSubject.next(true);
        console.log(file, 'file');

        this.dlService.deleteAttachment(file?.daily_log_id, file?.file_id).subscribe({
          next: (response: any) => {
            const { status, message } = response;
            if (status === 200) {
              this.openSnackbar(message);
            } else {
              this.openSnackbar('Something went wrong');
            }
          },
          error: (err) => {
            console.error('Delete attachment error:', err);
            this.openSnackbar('Something went wrong');
          },
          complete: () => {
            this.loadingSubject.next(false);
            this.getDailyLogs();
          }
        });
      }
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
